import { render, staticRenderFns } from "./paymerchant.vue?vue&type=template&id=46ed8c3e&"
import script from "./paymerchant.vue?vue&type=script&lang=js&"
export * from "./paymerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports